/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import BoardFrontierType from 'solis/logic/board/frontier.type';
import BoardProximity from 'solis/logic/board/proximity';
import ZoneUsers from 'solis/logic/board/zone/users';
import ZoneInfluences from 'solis/logic/board/zone/influences';


const buildArgs = ({ board, zone }) =>
{
  const args = {};

  args.galaxy = board.cass.galaxy;
  args.board = board.cass.id;
  args.zone = zone.getAbsoluteHex().toString();

  return args;
};


const validate = ({ board, zone, account }) =>
{
  const issues = [];

  if (!new ZoneUsers(zone).isColonyUser(account.cass.id))
  {
    issues.push('You are not the original owner of this zone');
  }

  if (!new ZoneUsers(zone).isCurrentUser(account.cass.id))
  {
    issues.push('You are not the current winner of this zone');
  }
  else if (!new BoardProximity(board, BoardFrontierType.Zone).isAccessibleByUser(zone.getAbsoluteHex(), account.cass.id))
  {
    issues.push('Zone is not accessible');
  }

  if (new ZoneInfluences(zone).getEnemyInfluences().length === 0)
  {
    issues.push('There is no enemy influence to surrender to');
  }

  return { valid: issues.length === 0, issues };
};


const isAvailable = ({ zone, account }) =>
{
  return zone !== null && new ZoneUsers(zone).isColonyUser(account.cass.id);
};


export default
{
  type: 'solis/board/zone/surrender',
  inputs: {},

  isAvailable,
  buildArgs,
  validate,
};
